import { Button, Modal } from 'coreOld/components';
import { WrapperBlock } from 'coreOld/elements';
import { ButtonType, Size } from 'coreOld/enums';

import { Message, WrapperBtn } from './confirmationStyle';

interface IProps {
  title: string;
  size: Size;
  message: string | JSX.Element;
  confirmBtnLabel?: string;
  confirmBtnType?: ButtonType;
  cancelBtnLabel?: string;
  cancelBtnType?: ButtonType;
  onConfirm?: () => void;
  onCancel?: () => void;
  isOpen: boolean;
}

const ConfirmationView = ({
  title,
  size,
  message,
  confirmBtnLabel,
  confirmBtnType,
  cancelBtnLabel,
  cancelBtnType,
  onConfirm,
  onCancel,
  isOpen,
}: IProps) => {
  return (
    <Modal title={title} isOpen={isOpen} onClose={onCancel} size={size}>
      <WrapperBlock>
        <Message>{message}</Message>
      </WrapperBlock>

      <WrapperBlock hideBorderBottom buttonWrapper>
        <WrapperBtn>
          <Button onClick={onConfirm} btnType={confirmBtnType}>
            {confirmBtnLabel}
          </Button>
        </WrapperBtn>

        <Button onClick={onCancel} btnType={cancelBtnType}>
          {cancelBtnLabel}
        </Button>
      </WrapperBlock>
    </Modal>
  );
};

export default ConfirmationView;
